import { render, staticRenderFns } from "./infectiousDiseaseListSchool.vue?vue&type=template&id=5b59d337&scoped=true&"
import script from "./infectiousDiseaseListSchool.vue?vue&type=script&lang=js&"
export * from "./infectiousDiseaseListSchool.vue?vue&type=script&lang=js&"
import style0 from "./infectiousDiseaseListSchool.vue?vue&type=style&index=0&id=5b59d337&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b59d337",
  null
  
)

export default component.exports